<template>
  <b-modal
    entrance-transition="animated fadeIn"
    leave-transition="animated bounceOut"
    ref="modal"
    :centered="true"
    no-close-on-backdrop
    no-close-on-esc
    ok-title="Conferma"
    ok-variant="success"
    cancel-title="Annulla"
    cancel-variant="outline-secondary"
    :title="title ? title : 'Comunicazioni per utente'"
    size="lg"
    :hideHeaderClose="true"
    header-class="my-header-class"
    footer-class="my-footer-class"
  >

    <div slot="modal-title">
      <img
        src="../assets/images/logo-solo-img.png"
        alt="AEqua Roma"
        style="height:2rem;"
      >
      {{title ? title : "Comunicazioni per l'utente"}}
    </div>

    <h2
      class="text-center mt-4 text-uppercase"
      style="color: #862633"
    >
      Comunicazioni da Aequa Roma
    </h2>
    <div class="text-center">
      Comunicazioni per l'utente del portale patrimonio
    </div>

    <div class="text-left mt-5 ">
      <span>
        <b>Data creazione messaggio: </b>{{formatDateTime(notifica ? notifica.timeStampCreazione : '') }}
      </span>
      <br>
    </div>
    <hr>
    <div>
      <b-form-textarea
        id="textarea-plaintext"
        :value="notifica ? notifica.oggetto : ''"
        rows=3
        :readonly="true"
      >
      </b-form-textarea>
    </div>
    <hr>
    <div>
      <b-button
        v-if="!nascondiMessaggio && !messaggioBreve"
        class="m-1"
        variant="link"
        @click="mostraMessaggio"
      >Nascondi Messaggio</b-button>
      <b-form-textarea
        v-if="nascondiMessaggio && !messaggioBreve"
        id="textarea-anteprima"
        :value="notifica ? anteprimaMessaggio : ''"
        rows=2
        :readonly="true"
      >
      </b-form-textarea>
      <b-button
        class="m-1"
        variant="link"
        v-if="nascondiMessaggio && !messaggioBreve"
        @click="doLeggiMessaggio"
      >Mostra messaggio completo</b-button>
      <!-- Element to collapse -->
      <b-form-textarea
        v-if="!nascondiMessaggio || messaggioBreve"
        id="textarea-plaintext"
        :value="notifica ? notifica.testo : ''"
        rows=6
        :readonly="true"
      >
      </b-form-textarea>
    </div>

    <template slot="modal-footer">

      <b-button
        v-if="notifica && !notifica.timeStampLettura && (flConfermaLettura || messaggioBreve)"
        variant="success"
        class="m-2"
        @click="doConfermaLettura"
      >
        <font-awesome-icon
          icon="check"
          class="text-white mr-2"
        />Conferma lettura
      </b-button>

      <!-- <b-button v-if="notifica.eliminato === 0" variant="primary" class="m-2" @click="doArchivia">
        <font-awesome-icon icon="save" class="text-white mr-2" />Archivia
      </b-button> -->

      <a
        v-if="notifica && notifica.allegato"
        target="_blank"
        :href="urlMessaggio"
      >
        <button
          class="btn btn-success m-2"
          @click="doScaricaAllegato"
        >
          <font-awesome-icon
            icon="download"
            class="text-white mr-2"
          />Scarica allegato
        </button>
      </a>
      <b-button
        variant="primary"
        @click="close"
      >
        <font-awesome-icon
          icon="times"
          class="mr-2"
        />Ho preso visione della comunicazione..
      </b-button>
    </template>
    <!-- </div> -->
  </b-modal>

</template>

<script>
import moment from 'moment'

export default {
  name: 'notificationModal',
  props: {
    title: { type: String }
  },
  data () {
    return {
      idx: -1,
      item: {},
      notifiche: [],
      notifica: {},
      leggiMessagioLungo: false,
      scaricaAllegato: false,
      nascondiMessaggio: true
    }
  },

  computed: {
    moment () {
      return moment
    },
    urlMessaggio () {
      return `/api/messages/${this.notifica.id}/download`
    },
    flMessagioLungo () {
      if (this.notifica && this.notifica.testo) {
        return false
      } else { return true }
    },
    flAllegato () {
      if (this.notifica && this.notifica.allegato) {
        return false
      } else { return true }
    },
    flConfermaLettura () {
      if ((this.flAllegato || this.scaricaAllegato) && (this.flMessagioLungo || this.leggiMessagioLungo)) {
        return true
      } else { return false }
    },
    anteprimaMessaggio () {
      if (this.notifica && this.notifica.testo) {
        return this.notifica.testo.substring(0, 250)
      } else {
        return ''
      }
    },
    messaggioBreve () {
      if (this.notifica && this.notifica.testo && this.notifica.testo.length > 250) {
        return false
      } else {
        return true
      }
    }

  },

  // async created () {
  //   await this.load()
  // },

  // async mounted () {
  //   this.$nextTick(()=>{
  //     await this.load()
  //   })
  // },

  methods: {
    async open () {
      try {
        await this.$store.dispatch('messages/loadPrimaVisione')
        this.notifiche = this.$store.state.messages.items

        // console.log('Elenco notifiche primo accesso', this.notifiche)

        this.notifica = this.notifiche ? this.notifiche[0] : null

        this.$refs.modal.show()

        // console.log('this.dichiarazioniIsVisible', this.dichiarazioniIsVisible)
      } catch (err) {
        this.$ui.showError(err)
      }
    },
    async close () {
      // let appData = moment(this.notifica.timeStampCreazione).format('DD/MM/YYYY HH:MM')

      // console.log('appData', appData)

      try {
        await this.$store.dispatch('messages/confermaVisione', this.notifica)

        this.$ui.notify({
          type: 'success',
          title: 'Esito operazione',
          message: `Confermata presa visione comunicazione!`
        })

        this.doNext()

        // this.back()
      } catch (err) {
        this.$ui.showError(err)
        // back()
      }
    },
    mostraMessaggio () {
      this.nascondiMessaggio = !this.nascondiMessaggio
    },
    doScaricaAllegato () {
      this.scaricaAllegato = true
    },
    doLeggiMessaggio () {
      this.nascondiMessaggio = !this.nascondiMessaggio
      this.leggiMessagioLungo = true
    },
    doConfermaLettura () {
      this.$ui.notify({
        type: 'confirm',
        title: 'Richiesta di conferma',
        message: 'Confermi la resa visione della comunicazione?',
        okHandler: this.doConferma
      })
    },
    async doConferma () {
      try {
        await this.$store.dispatch('messages/confermaLettura', this.notifica)

        this.$ui.notify({
          type: 'success',
          title: 'Esito operazione',
          message: `Confermata lettura comunicazione!`
        })
        this.doNext()
      } catch (err) {
        this.$ui.showError(err)
        // back()
      }
      this.loading = false
    },
    async doNext () {
      this.leggiMessagioLungo = false
      this.scaricaAllegato = false
      this.nascondiMessaggio = true
      try {
        await this.$store.dispatch('messages/loadPrimaVisione')
        this.notifiche = this.$store.state.messages.items
        this.notifica = this.notifiche ? this.notifiche[0] : null
        // console.log('messages/loadPrimaVisione', this.notifica, this.notifiche)
        if (this.notifica) {
          this.$refs.modal.hide()
          this.$refs.modal.show()
        } else {
          // console.log('Uscita prima visione delle notifiche!')
          this.$refs.modal.hide()
        }
      } catch (err) {
        this.$ui.showError(err)
        // back()
      }
      this.loading = false
    },
    formatDateTime (dateStr) {
      return dateStr ? moment(dateStr).format('DD/MM/YYYY HH:mm') : ''
    }
  }
}
</script>

<style lang="stylus" scoped>
.btn-left >>> button {
  text-align: left !important;
}

/deep/ .my-header-class {
  background: #862633;
  color: white;
}

/deep/ .my-footer-class {
  color: #862633;
}
</style>
